module.exports = __webpack_public_path__ + "img/bfxs2.f4bd81b0.png";